import React, { useEffect, useState } from 'react';
import { api } from '../../api/client';
import RichTextEditor from './RichTextEditor';
import { LANGUAGES, fieldSuffix } from '../../i18n/languages';

import { ta } from '../../i18n/adminT';
const emptyTemplate = { subjectIt: '', bodyHtmlIt: '', subjectEn: '', bodyHtmlEn: '', subjectRo: '', bodyHtmlRo: '' };

// Suggerimenti mostrati nei campi vuoti, nella lingua della scheda attiva
const PLACEHOLDERS = {
  it: { subject: 'Grazie per il tuo contatto', body: 'Ciao {{nome}} {{cognome}}, grazie per averci lasciato il tuo contatto…' },
  en: { subject: 'Thanks for your contact', body: 'Hi {{nome}} {{cognome}}, thanks for leaving your contact details…' },
  ro: { subject: 'Vă mulțumim pentru contact', body: 'Bună ziua, {{nome}} {{cognome}}, vă mulțumim că ne-ați lăsat datele de contact…' },
};

export default function ContactEmailSettings() {
  const [template, setTemplate] = useState(emptyTemplate);
  const [activeLang, setActiveLang] = useState('it');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    api.getContactEmailTemplate()
      .then((res) => setTemplate({ ...emptyTemplate, ...res.data }))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const updateSubject = (e) => {
    setSaved(false);
    setTemplate((t) => ({ ...t, [`subject${fieldSuffix(activeLang)}`]: e.target.value }));
  };

  const updateBody = (html) => {
    setSaved(false);
    setTemplate((t) => ({ ...t, [`bodyHtml${fieldSuffix(activeLang)}`]: html }));
  };

  const handleSave = async () => {
    setError('');
    setSaved(false);
    setSaving(true);
    try {
      await api.saveContactEmailTemplate(template);
      setSaved(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  if (loading) return null;

  const subjectValue = template[`subject${fieldSuffix(activeLang)}`] || '';
  const bodyValue = template[`bodyHtml${fieldSuffix(activeLang)}`] || '';

  return (
    <div>
      <h1 className="admin-page-title">{ta('Email contatti')}</h1>
      <p className="admin-page-subtitle">
        {ta('Testo inviato a chi lascia il proprio contatto dalla pagina')} <span className="mono">{ta('/contatti')}</span>{ta(', con l\'informativa privacy allegata. Indipendente dall\'email di benvenuto usata per le registrazioni del controllo ingressi.')}
      </p>

      <div className="admin-card" style={{ maxWidth: 640 }}>
        {error && <div className="form-error">{error}</div>}
        {saved && (
          <div style={{ background: 'rgba(62,142,126,0.12)', color: 'var(--teal-green-dark)', borderRadius: 'var(--radius-control)', padding: '10px 14px', fontSize: '0.85rem', marginBottom: 16 }}>
            {ta('Impostazioni salvate.')}
          </div>
        )}

        <div className="btn-row" style={{ marginBottom: 18 }}>
          {LANGUAGES.map(({ key, label, flag }) => (
            <button
              key={key}
              type="button"
              className={activeLang === key ? 'btn btn-primary' : 'btn btn-ghost'}
              onClick={() => setActiveLang(key)}
            >
              {flag} {label}
            </button>
          ))}
        </div>

        <div className="field">
          <label>{ta('Oggetto')}</label>
          <input
            type="text"
            value={subjectValue}
            onChange={updateSubject}
            maxLength={300}
            placeholder={PLACEHOLDERS[activeLang].subject}
          />
        </div>

        <div className="field">
          <label>{ta('Testo email')}</label>
          <RichTextEditor
            key={activeLang}
            value={bodyValue}
            onChange={updateBody}
            placeholder={PLACEHOLDERS[activeLang].body}
          />
        </div>

        <p style={{ fontSize: '0.78rem', color: 'var(--muted-text)', marginBottom: 10 }}>
          {ta('Puoi usare')} <span className="mono">{ta('{{nome}}')}</span> {ta('e')} <span className="mono">{ta('{{cognome}}')}</span> {ta('nel testo: verranno sostituiti con i dati della persona che ha lasciato il contatto. Se lasci oggetto o testo vuoti per una lingua, verrà usato un testo predefinito.')}
        </p>
        <p style={{ fontSize: '0.78rem', color: 'var(--muted-text)', marginBottom: 18 }}>
          {ta('Le immagini (es. il logo nella firma aziendale) vengono incorporate direttamente nel testo dell\'email: funzionano nella maggior parte dei client di posta, ma preferisci sempre un\'immagine piccola e leggera (max 200 KB) — alcuni client aziendali più datati potrebbero non mostrare immagini incorporate in questo modo.')}
        </p>

        <button
          type="button"
          className="btn btn-primary"
          onClick={handleSave}
          disabled={saving}
          style={{ width: 'auto', padding: '10px 20px' }}
        >
          {saving ? ta('Salvataggio…') : ta('Salva')}
        </button>
      </div>
    </div>
  );
}
